<template>
  <div>
    <div class="highlight-container official-video-container px-4">
      <div class="highlight-wrapper pt-4" style="width: 100%">
        <div>{{ $t(`label.officialVideo`) }}</div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box" style="overflow-x:hidden;">
          <v-img :src="`/static/image/officialVideo/official-video-bg.jpg`">
            <v-row no-gutters class="fill-height">
              <v-col cols="6">
              </v-col>
              <v-col cols="6" class="video-container">
                <div class="official-video">
                  <iframe src="https://www.youtube.com/embed/dFDQLcrRwWY" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </v-col>
            </v-row>
          </v-img>
        </div>
        <div v-if="$vuetify.breakpoint.smAndDown" class="matches-box" style="overflow-x:hidden; width: 100%; padding-bottom: 0;">
          <v-img :src="`/static/image/officialVideo/official-video-bg-m.jpg`">
            <v-row no-gutters class="fill-height">
              <v-col cols="12">
              </v-col>
              <v-col cols="12" class="video-container">
                <div class="official-video">
                  <iframe src="https://www.youtube.com/embed/dFDQLcrRwWY" style="position: absolute; bottom: 0; left: 0; width: 100%; height: 100%;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </v-col>
            </v-row>
          </v-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OfficialVideoHomeBanner'
  }
</script>

<style lang="scss">
  .official-video-container {
    max-height: 100%;

    @media (max-width: 959px) {
      padding-bottom: 12px;
    }

    .official-video-bg {
      width: 100%;
      max-height: 526px;
      max-width: 100vw;
      padding: 8px 0;
      background-image: url(/static/image/officialVideo/official-video-bg-m.jpg);
      background-size: cover;
    }

    .video-container {
      width: 100%;
      height: 100%;
      align-content: center;

      @media (max-width: 959px) {
        width: 420px;
        height: auto;
        max-width: 100%;
        padding: 0 !important;
      }

      .official-video {
        position: relative;
        padding-bottom: 56.25%;
        overflow: hidden;
        max-width: 96%;
        margin-left: 2%;
        height: auto;

        @media (max-width: 959px) {
          padding-bottom: 51%;
          max-width: 92%;
          margin-left: 4%;
          bottom: -8%;
        }
      }
    }
  }
</style>